const LXP_FILE_QUERY = 
`query lxpFile( $lxpFileID: UUID! ) {
    lxpFile(lxpFileID: $lxpFileID) {
        node {
            signedUrl
        }
    }
}`;

const getFileQuery = ( options = {} ) => {
    const result = {
        query: LXP_FILE_QUERY,
        operationName: 'lxpFile',
        variables: { ...options }
    };

    return JSON.stringify( result );
};

export default getFileQuery;
